// import { routes as supplierConfigRoutes } from "./suppliers/routes";
// import { routes as supplierTypeRoutes } from "./supplier-types/routes";
// import { routes as messageRoutes } from "./messages/routes";
// import { routes as shippingCompanyRoutes } from "./shipping-companies/routes";
// import { routes as invoiceRoutes } from "./invoices/routes";
// import { routes as grnRoutes } from "./grns/routes";
// import { routes as lposRoutes } from "./lpos/routes";
// import { routes as journalRoutes } from "./journals/routes";
// import { routes as approvalsRoutes } from "./approvals/routes";
// import { routes as reportRoutes } from "./reports/routes";
export const routes  = (prefix = `sales`) => [
    {
        path: `/${prefix}`,
        name: `${prefix}.index`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "sales Dashboard",
            },
        },
    }, {
        path: `/${prefix}/sale-receipt/:ReceiptNo`,
        name: `${prefix}.sale-receipt.print`,
        component: () => import('./print/Receipt.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName: `sale-receipt.print`,
                PageDescription: "Sales Receipt Print",
            },
            print: true,
        },
        
    }, {
        path: `/${prefix}/Report`,
        name: `${prefix}.report`,
        component: () => import('./Report.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName:  `${prefix}.report`,
                PageDescription: "Sales Report",
            },
            print: true,
        },
        
        
    }, {
        path: `/${prefix}/PendingSales`,
        name: `${prefix}.pendingsales`,
        component: () => import('./PendingSales.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName:  `${prefix}.pendingsales`,
                PageDescription: "Pending Sales",
            },
            print: true,
        },
        
        
    }, {
        path: `/${prefix}/Reverse`,
        name: `${prefix}.reverse`,
        component: () => import('./reverse/Index.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName:  `${prefix}.reverse`,
                PageDescription: "Reverse Sales",
            },
            print: true,
        },
        
        
    }, {
        path: `/${prefix}/sale-reverse/:ReceiptNo`,
        name: `${prefix}.sale-reverse.reverse`,
        component: () => import('./reverse/ReverseSales.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName:  `${prefix}.reverse`,
                PageDescription: "Reverse Sales",
            },
            print: true,
        },
        
    },
    { 
        name: `${prefix}..sales-report.print`,
        path: `/${prefix}/sales-report/print`,
        component: () => import('./print/PrintReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName:  `${prefix}.report`,
                PageDescription: "Sales Report",
            },
            print: true,
        },
    },
    // ...supplierConfigRoutes(),
    // ...supplierTypeRoutes(),
    // ...messageRoutes(),
    // ...shippingCompanyRoutes(),
    // ...invoiceRoutes(),
    // ...grnRoutes(),
    // ...lposRoutes(),
    // ...journalRoutes(),
    // ...approvalsRoutes(),
    // ...reportRoutes(),
];